import { FamilyPlanTypes } from '../../common/services/package/package.model';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';

export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('familyPlanMemberInfo', {
    component: 'fizyPaycellFamilyPlanMemberInfo',
    parent: 'mainWrapper',
    resolve: {
      invoice: [
        '$q',
        'globalSpinner',
        ($q, globalSpinner: GlobalSpinnerService) => {
          globalSpinner.start();
          return globalSpinner.stop();
        }
      ],
      type: [() => { return FamilyPlanTypes.FAMILY; }]
    },
    url: '/family-plan-member-info'
  });
  $stateProvider.state('duoPlanMemberInfo', {
    component: 'fizyPaycellFamilyPlanMemberInfo',
    parent: 'mainWrapper',
    resolve: {
      invoice: [
        '$q',
        'globalSpinner',
        ($q, globalSpinner: GlobalSpinnerService) => {
          globalSpinner.start();
          return globalSpinner.stop();
        }
      ],
      type: [() => { return FamilyPlanTypes.DUO; }]
    },
    url: '/duo-plan-member-info'
  });
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-member-info/family-plan-member-info.routes.ts